export { Filters as default, demoOnly, schoolOnly }

const Filters = [
  { field: 'Sector', isSchoolLevel: true },
  { field: 'Current Network', label: 'Network', isSchoolLevel: true },
  { field: 'School Level', isSchoolLevel: true },
  { field: 'Admission Type', isSchoolLevel: true },
  { field: 'Grade', label: 'Grade Level' },
  { field: 'Race/Ethnicity' },
  { field: 'Gender' },
  { field: 'Economic Disadvantage' },
  { field: 'Special Education' },
  { field: 'EL Status' },
]

/*const demoOnly = [
  { field: 'Grade', label: 'Grade Level' },
  { field: 'Race/Ethnicity' },
  { field: 'Gender' },
  { field: 'Economic Disadvantage' },
  { field: 'Special Education' },
  { field: 'EL Status' },
] */

const demoOnly = Filters.filter(({ isSchoolLevel }) => !isSchoolLevel)

const schoolOnly = Filters.filter(({ isSchoolLevel }) => !!isSchoolLevel)